/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 新闻服务接口
 */

import xhr from './xhr/index'
import { BaseParams } from './index'

interface IGetDetailParams {
    id: number   // 新闻 ID
    media_type?: any
}

interface INewsListParams {
    news_type?: number,   // 新闻类型
    search_type?: number, // 搜索类型
    query?: string,       // 搜索内容
    reporter_id?: number, // 记者 ID
    media_id?: number,    // 媒体 ID
    page_index: number    // 第几页
    page_size: number     // 每页条数
}

interface IPlatformsParams {
    news_id?: number      // 新闻 ID
    media_type?: any // 媒体类型
}

interface ICommentsParams {
    news_id: number       // 新闻 ID
    platform_id?: number  // 平台 ID
    page_index?: number   // 第几页
    page_size?: number    // 每页条数
}

interface IMeta {
    id: number
    read_count: number
    like_count: number
    comment_count: number
    share_count: number
    interact_count: number
    origin_url: string
}

interface IUpdateNewsParams {
    id: number
    title?: string
    content?: string
    is_deleted?: boolean
    meta_datas?: IMeta[]
    published_at?: string
}

interface IAddNewsParams {
    rid: number
    title: string
    published_at: string
    content: string
    meta_datas: IMeta[]
    media_type?: string
}

interface IExtractArticleParams {
    title: string
    content: string
}

interface IGetRecomendListParams extends BaseParams {}

interface ICreateRecomendListParams {
    id: number           // 新闻 id
}

interface IDeleteRecomendListParams {
    id: number           // 新闻 id
}
interface IExportNewsParams {
    keywords: string[]       // 关键词
    published_at_gte: string // 发表时间大于等于
    published_at_lte: string // 发表时间小于等于
    columns: string[]        // 导出的字段
}

class NewsService {
    /** 获取新闻详情 */
    public async getDetail(params: IGetDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/news',
            params: params
        })
        return result
    }
    /** 获取新闻列表的筛选条件 */
    public async getFilterCondition(params?: {}) {
        const result = await xhr({
            method: 'get',
            url: '/news/list/filters',
            params: params
        })
        return result
    }
    /** 获取新闻列表 */
    public async getList(params: INewsListParams) {
        const result = await xhr({
            method: 'get',
            url: '/news/list',
            params: params 
        })
        return result
    }
    /** 获取新闻的平台数据 */
    public async getPlatforms(params: IPlatformsParams) {
        const result = await xhr({
            method: 'get',
            url: '/news/platforms',
            params: params
        })
        return result
    }
    /** 获取新闻的父级评论 */
    public async getRootComments(params: ICommentsParams) {
        const result = await xhr({
            method: 'get',
            url: '/news/root_comments',
            params: params
        })
        return result
    }
    /** 获取新闻的子级评论 */
    public async getChildComments(params: ICommentsParams) {
        const result = await xhr({
            method: 'get',
            url: '/news/child_comments',
            params: params
        })
        return result
    }
    /** 更新新闻 */
    public async updateNews(params: IUpdateNewsParams) {
        const result = await xhr({
            method: 'put',
            url: '/news',
            params: params 
        })
        return result
    }
    /** 新增新闻 */
    public async addNews(params: IAddNewsParams) {
        const result = await xhr({
            method: 'post',
            url: '/news',
            params: params 
        })
        return result
    }
    /** 文章数据提取 */
    public async extractArticle(params: IExtractArticleParams) {
        const result = await xhr({
            method: 'post',
            url: '/article/extract',
            params: params 
        })
        return result
    }
    /** 获取推荐新闻列表 */
    public async getRecommendNewsList(params: IGetRecomendListParams) {
        const result = await xhr({
            method: 'get',
            url: '/news/recommend/list',
            params: params 
        })
        return result
    }
    /** 新增推荐新闻 */
    public async createRecommendNews(params: ICreateRecomendListParams) {
        const result = await xhr({
            method: 'post',
            url: '/news/recommend',
            params: params 
        })
        return result
    }
    /** 删除推荐新闻 */
    public async deleteRecommendNews(params: IDeleteRecomendListParams) {
        const result = await xhr({
            method: 'delete',
            url: '/news/recommend',
            params: params 
        })
        return result
    }

    /** 新闻导出支持的字段 */
    public async getNewsExportColumns(params: any) {
        const result = await xhr({
            method: 'get',
            url: '/news/export_columns',
            params: params 
        })
        return result
    }
    /** 导出新闻数据 */
    public async exportNewsData(params: IExportNewsParams) {
        const result = await xhr({
            method: 'post',
            url: '/news/export',
            params: params 
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new NewsService()
